export class PCMPlayer {
  audioContext: AudioContext;
  playbackTime: number;
  gainNode: GainNode;
  analyser?: AnalyserNode;
  array: Float32Array[];
  sources: AudioBufferSourceNode[];
  needToReset: boolean;

  constructor(audioContext: AudioContext, analyser?: AnalyserNode) {
    this.audioContext = audioContext;
    this.analyser = analyser;
    this.playbackTime = 0;
    this.gainNode = this.audioContext.createGain();
    this.gainNode.connect(this.audioContext.destination);
    this.array = [];
    this.needToReset = false;
    this.sources = [];
  }

  onend(e: any) {
    console.log("ended", e);
  }

  stop() {
    this.needToReset = true;
    this.sources.forEach((source) => {
      source.stop();
    });
  }

  repeat() {
    this.array.forEach((a) => this.playAudio(a, true));
  }

  async playAudio(data: Int16Array | Float32Array, isRepeat = false) {
    if (this.audioContext.state !== "running") {
      console.error(`Audio context is in ${this.audioContext.state} state`);
    }
    const float32Array = data instanceof Int16Array ? pcm16ToFloat32(data) : data;
    if (!isRepeat) {
      if (this.needToReset) {
        this.array = [];
        this.sources = [];
        this.needToReset = false;
      }
      this.array.push(float32Array);
    }

    const audioBuffer = this.audioContext.createBuffer(1, float32Array.length, this.audioContext.sampleRate);
    audioBuffer.copyToChannel(float32Array, 0);
    const source = this.audioContext.createBufferSource();
    source.buffer = audioBuffer;
    const currentTime = this.audioContext.currentTime;
    if (this.playbackTime < currentTime) {
      this.playbackTime = currentTime;
    }
    source.connect(this.gainNode);
    if (this.analyser) {
      source.connect(this.analyser);
    }
    source.start(this.playbackTime);
    this.sources.push(source);

    this.playbackTime += audioBuffer.duration;
  }
}
const pcm16ToFloat32 = (pcm16: Int16Array) => {
  const float32 = new Float32Array(pcm16.length);
  for (let i = 0; i < pcm16.length; i++) {
    float32[i] = pcm16[i] / 32768;
  }
  return float32;
};
